import sanitizeHTML from "sanitize-html";

export default {
  install(app) {
    app.prototype.$sanitize = sanitizeHTML;
  },
};
